export const Funcionalidades = {
  oitiva: {
    cadastrar: 'mac-func-oitiva_cadastrar',
    consultar: 'mac-func-oitiva_consultar',
    editar: 'mac-func-oitiva_alterar',
    visualizar: 'mac-func-oitiva_visualizar',
    finalizar: 'mac-func-oitiva_finalizar',
    excluir: 'mac-func-oitiva_excluir',
    resumoVisualizar: 'mac-func-oitiva_resumo_visualizar',
    rascunhoVisualizar: 'mac-func-oitiva_rascunho_visualizar',
    download: 'mac-func-oitiva_download',
    retificar: 'mac-func-oitiva_retificar',
    termoEntrega: {
      expedir: 'mac-func-oitiva_termo_entrega_expedir',
      visualizar: 'mac-func-oitiva_termo_entrega_visualizar',
    },
  },
  fichaAdolescente: {
    consultar: 'mac-func-ficha_adolescente_consultar',
    cadastrar: 'mac-func-ficha_adolescente_cadastrar',
    editar: 'mac-func-ficha_adolescente_editar',
    visualizar: 'mac-func-ficha_adolescente_visualizar',
    imprimir: 'mac-func-ficha_adolescente_imprimir',
    exportar: 'mac-func-ficha_adolescente_exportar',
    visualizarMedidasUnificadas: 'mac-func-ficha_adolescente_visualizar_medidas_unificadas',
  },
  integraPolicial: {
    consultar: 'mac-func-integra_policial_consultar',
    visualizar: 'mac-func-integra_policial_visualizar',
    editar: 'mac-func-integra_policial_editar',
    finalizar: 'mac-func-integra_policial_finalizar',
    adolescente: {
      adicionar: 'mac-func-integra_policial_adolescente_adicionar',
      excluir: 'mac-func-integra_policial_adolescente_excluir',
      informarStatus: 'mac-func-integra_policial_adolescente_informar_status',
      iniciarOitiva: 'mac-func-integra_policial_adolescente_iniciar_oitiva',
    },
  },
  relatorio: {
    auditoria: {
      fichaAdolescente: {
        consultar: 'mac-func-relatorio_ficha_adolescente_consultar',
      },
    },
  },
  notificacoes: {
    consultar: 'mac-func-notificacoes_consultar',
    visualizar: 'mac-func-notificacoes_visualizar',
    excluir: 'mac-func-notificacoes_excluir',
  },
  creas: {
    consultar: 'mac-func-creas_consultar',
    visualizar: 'mac-func-creas_visualizar',
    excluir: 'mac-func-creas_excluir',
    cadastrar: 'mac-func-creas_cadastrar',
    editar: 'mac-func-creas_editar',
  },
  meioAberto: {
    consultar: 'mac-func-meio-aberto_consultar',
    visualizar: 'mac-func-meio-aberto_visualizar',
    excluir: 'mac-func-meio-aberto_excluir',
    cadastrar: 'mac-func-meio-aberto_cadastrar',
    editar: 'mac-func-meio-aberto_editar',
    medidasAplicadas: {
      visualizarAnexos: 'mac-func-meio-aberto_med-apl_visualizar-anexos',
    },
    historico: 'mac-func-meio-aberto_historico',
    relatorio: {
      gerar: 'mac-func-meio-aberto_relatorio_gerar',
    },
  },
  /*
   * PIA (Planejamento Individual de Atendimento) — passo 6 do meio-aberto, OS30.
   *
   * NÃO tem chave própria: usa `meioAberto` acima. A D8 do brief previa
   * mac-func-pia_{consultar,cadastrar,editar,excluir}, revista em 2026-07-21 —
   * as 4 roles nunca existiram no realm (risco R6) e dariam 403 em todos até
   * alguém atualizar o Keycloak. O PIA é um passo do meio-aberto, sem porta de
   * entrada própria, então herda o acesso do caso.
   *
   * Leitura -> meioAberto.visualizar; escrita -> meioAberto.editar.
   * O backend faz o mesmo mapeamento (Funcionalidades.java), então o que a tela
   * habilita é exatamente o que o servidor aceita.
   */
  comunicacaoCSI: {
    consultar: 'mac-func-comunicacao-csi_consultar',
    cadastrar: 'mac-func-comunicacao-csi_cadastrar',
    configurar: 'mac-func-comunicacao-csi_configurar',
  },
  vincularProcessos: {
    vincular: 'mac-func-vincular-processo',
    gerenciarGuias: 'mac-func-guia-execucao_gerenciar',
  },
}

export const hearingFunctionalities = {
  cadastrar: 'mac-func-oitiva_cadastrar',
  consultar: 'mac-func-oitiva_consultar',
  editar: 'mac-func-oitiva_alterar',
  visualizar: 'mac-func-oitiva_finalizar',
  finalizar: 'mac-func-oitiva_finalizar',
  excluir: 'mac-func-oitiva_excluir',
  resumoVisualizar: 'mac-func-oitiva_resumo_visualizar',
  rascunhoVisualizar: 'mac-func-oitiva_rascunho_visualizar',
  download: 'mac-func-oitiva_download',
  retificar: 'mac-func-oitiva_retificar',
}

export const teenagerRecordFunctionalities = {
  consultar: 'mac-func-ficha_adolescente_consultar',
  visualizar: 'mac-func-ficha_adolescente_visualizar',
  imprimir: 'mac-func-ficha_adolescente_imprimir',
  exportar: 'mac-func-ficha_adolescente_exportar',
  editar: 'mac-func-ficha_adolescente_editar',
}
